import { Component, Input, ContentChild, ViewChild, ElementRef, TemplateRef, Output, EventEmitter } from '@angular/core';

import { IconMode } from '../../icon/icon.component';

import { TabLabelDirective } from '../directives/label.directive';

@Component({
  selector: 'uex-tab',
  templateUrl: './tab.component.html'
})
export class TabComponent{
  /** Content for the tab label given by <ng-template md-tab-label>. */
  @ContentChild(TabLabelDirective, { static: false }) templateLabel: TabLabelDirective;

  /** Template inside the MdTab view that contains an <ng-content>. */
  @ViewChild(TemplateRef, { static: true }) content: TemplateRef<any>;

  /** The plain text label for the tab, used when there is no template label. */
  @Input('label') public textLabel: string = '';

  /** The title for the tab, used to shows a custom description for the tab action. */
  @Input('title') public title: string = '';

  @Input('disabled') public disabled: boolean = false;

  @Input('class') public class_name: any;

  /**Used to set the type, if is a simple tab or button tab */
  @Input('type') public type: string = 'tab';

  /**Used to define the color of a tab button label/icon */
  @Input('color') public color?: string;

  /**Used to show the icon of a tab button */
  @Input('icon') public icon?: string;

  /**Used to set the icon mode */
  @Input('iconMode') public icon_mode?: IconMode = 'md';

  /**Used to set the icon placement */
  @Input('iconPlacement') public icon_placement?: 'left' | 'right' = 'left';

  /**Used to emit click event in a button tab */
  @Output('onClick') public onClick: EventEmitter<MouseEvent> = new EventEmitter();

  constructor(public elementRef: ElementRef) { }

  public active: boolean = false;
}
